import React from 'react';
import { PrimaryActionButton, ConfirmationDialog } from '@facet-wealth/design';
import useMountedGuard from 'Hooks/useMountedGuard';

const SelectScenarioButton = ({
  buttonLabel,
  onConfirm,
}) => {
  const { doWithMountedGuard } = useMountedGuard();
  const [showConfirmDialog, _setShowConfirmDialog] = React.useState(false);
  const [loading, _setLoading] = React.useState(false);
  const setShowConfirmDialog = doWithMountedGuard(_setShowConfirmDialog);
  const setLoading = doWithMountedGuard(_setLoading);

  return (
    <>
      <PrimaryActionButton
        label={buttonLabel}
        onClick={() => {
          setShowConfirmDialog(true);
        }}
      />
      <ConfirmationDialog
        open={showConfirmDialog}
        onConfirm={async () => {
          try {
            setLoading(true);

            await onConfirm();

            setLoading(false);
            setShowConfirmDialog(false);
          } catch (err) {
            setLoading(false);
            setShowConfirmDialog(false);
            throw err;
          }
        }}
        loading={loading}
        onClose={() => setShowConfirmDialog(false)}
        confirmLabel={'Confirm Selection'}
        title={"You're so close..."}
        message={'Lock in your scenario to unlock the path ahead. As life happens and things change (they will!), we\'ll adjust your scenario to keep you on track.'}
      />
    </>
  );
};

export default SelectScenarioButton;
